import { useCallback, useEffect, useRef, useState } from 'react';

export const useCustomContextMenu = targetId => {
  const [contextMenuKey, setContextMenuKey] = useState('');
  const popoverTarget = useRef(null);

  useEffect(() => {
    const div = document.createElement('div');

    div.id = targetId;
    div.style.position = 'absolute';
    div.style.height = '0px';
    div.style.width = '0px';
    div.style.pointerEvents = 'none';
    document.body.appendChild(div);

    popoverTarget.current = div;

    return () => {
      popoverTarget.current = null;

      const element = document.getElementById(targetId);

      if (element) {
        document.body.removeChild(element);
      }
    };
  }, [targetId]);

  const updateContextMenuPosition = useCallback(
    (left, top) => {
      const element = document.getElementById(targetId);

      if (element) {
        element.style.left = `${left}px`;
        element.style.top = `${top}px`;
      }

      setContextMenuKey(crypto.randomUUID());
    },
    [targetId],
  );

  const toggleContextMenu = useCallback(() => {
    setContextMenuKey('');
  }, []);

  return {
    popoverTarget,
    contextMenuKey,
    updateContextMenuPosition,
    toggleContextMenu,
  };
};
